










import Vue from 'vue'

export default Vue.extend({
	props: ["params"],
	computed: {
		isPinnedTotal(this: any): boolean {
			return this.params?.node?.rowPinned === 'bottom' && this.params?.data?.isTotalRow === true
		},
	},
})
